import { render } from "./ModalWithdrawUsdtAccept.vue?vue&type=template&id=c9ad6f98&scoped=true&ts=true"
import script from "./ModalWithdrawUsdtAccept.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawUsdtAccept.vue?vue&type=script&lang=ts"

import "./ModalWithdrawUsdtAccept.vue?vue&type=style&index=0&id=c9ad6f98&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ad6f98"]])

export default __exports__